/* eslint-disable max-len */
import React from 'react'

type Props = {
  isLocked: boolean
}

const black = '#000000'

function LockReveleerIcon(
  props: Props
): JSX.Element {
  const { isLocked } = props
  if (isLocked) {
    return (
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 6.66667H13V4.7619C13 2.13333 10.76 0 8 0C5.24 0 3 2.13333 3 4.7619V6.66667H2C0.9 6.66667 0 7.52381 0 8.57143V18.0952C0 19.1429 0.9 20 2 20H14C15.1 20 16 19.1429 16 18.0952V8.57143C16 7.52381 15.1 6.66667 14 6.66667ZM8.00007 15.2381C6.90007 15.2381 6.00007 14.381 6.00007 13.3334C6.00007 12.2857 6.90007 11.4286 8.00007 11.4286C9.10007 11.4286 10.0001 12.2857 10.0001 13.3334C10.0001 14.381 9.10007 15.2381 8.00007 15.2381ZM4.99993 4.76193V6.66669H10.9999V4.76193C10.9999 3.18098 9.65993 1.90479 7.99993 1.90479C6.33993 1.90479 4.99993 3.18098 4.99993 4.76193Z"
          fill={ black }
        />
      </svg>
    )
  }
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 6.66667H13V4.7619C13 2.13333 10.76 0 8 0C5.24 0 3 2.13333 3 4.7619H5C5 3.18095 6.34 1.90476 8 1.90476C9.66 1.90476 11 3.18095 11 4.7619V6.66667H2C0.9 6.66667 0 7.52381 0 8.57143V18.0952C0 19.1429 0.9 20 2 20H14C15.1 20 16 19.1429 16 18.0952V8.57143C16 7.52381 15.1 6.66667 14 6.66667ZM14 18.0952H2.00002V8.57141H14V18.0952ZM10.0001 13.3334C10.0001 14.381 9.10007 15.2381 8.00007 15.2381C6.90007 15.2381 6.00007 14.381 6.00007 13.3334C6.00007 12.2857 6.90007 11.4286 8.00007 11.4286C9.10007 11.4286 10.0001 12.2857 10.0001 13.3334Z"
        fill={ black }
      />
    </svg>

  )
}

export default LockReveleerIcon
